import React, { Component } from 'react';
import gift_ic from '../../../images/gift_ic.svg';
import i18n from '../../../translation/translation';
import { Link } from 'react-router-dom';
import './completion.css';

class OfferPage extends Component {
  render() {
    return (
      <div className="op-container">
        <div className="end-lesson-div" align="center">
          <img className="op-img" src={gift_ic} alt="gift_ic" />
          <label className="sc-lbl"> {i18n('gift')} </label>
          <label className="usc-msg">{i18n('week-off-training')}</label>
          <button className="sc-btn"> {i18n('continue')} </button>
          <Link to="/">
            <p className="op-nt">{i18n('no-thanks-caps')}</p>
          </Link>
        </div>
      </div>
    );
  }
}
export default OfferPage;
